<template>
  <el-input
    :value="value"
    v-bind="$attrs"
    :type="type"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    @input="inputHandler"
  >
    <slot />
    <rt-icon slot="suffix" name="rt-base-edit" />
  </el-input>
</template>

<script>
export default {
  name: 'RtInput',
  props: {
    placeholder: {
      type: String,
      default: '暂无'
    },
    value: [String, Number],
    datafieldname: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  methods: {
    inputHandler(newValue) {
      this.$emit('input', newValue, null, this.datafieldname);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtInput.vue?4086e216